import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Form, Formik } from "formik";
import useProductName from "brand-customization/useProductName";
import { Button, Col, Modal, Row } from "components/bootstrap";
import FormikInput from "components/common/FormikInput";
import Spinner from "components/common/Spinner";
import { InputDescription, ModalSubmit, IfPermitted } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
import useEnableAIReportMutation from "security-app/components/Investigations/AIReport/hooks/useEnableAIReportMutation";
const LabelSpan = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    font-weight: bold;
  `
);
const AIReportConfiguration = () => {
  const { data, isLoading } = useAIConfiguration();
  const [showModal, setShowModal] = useState(false);
  const { enable, disable } = useEnableAIReportMutation();
  const productName = useProductName();
  const sendTelemetry = useSendTelemetry("investigation-ai-report");
  const _saveConfig = (values) => {
    const action = values.isEnabled ? enable : disable;
    action().then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.AI_REPORT_CONFIGURATION_SAVED, {
        app_pathname: "configurations"
      });
      setShowModal(false);
    });
  };
  const _resetConfig = () => {
    setShowModal(false);
  };
  const title = "AI Feature Services";
  const modalTitle = `Configure ${title}`;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, title), /* @__PURE__ */ React.createElement("p", null, "Manage access to AI-powered capabilities within ", productName, ". Enable or disable AI-driven features for your environment."), isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dl", { className: "deflist" }, /* @__PURE__ */ React.createElement("dt", null, "Status:"), /* @__PURE__ */ React.createElement("dd", null, data.isEnabled ? "Enabled" : "Disabled")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "*" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize: "xs",
      bsStyle: "info",
      onClick: () => {
        setShowModal(true);
      }
    },
    "Edit configuration"
  ))), /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: _resetConfig }, /* @__PURE__ */ React.createElement(Formik, { onSubmit: _saveConfig, initialValues: data }, ({ isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      name: "isEnabled",
      id: "isEnabled",
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, "Enabled")
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { help: /* @__PURE__ */ React.createElement(React.Fragment, null, "Enable or disable AI-driven features for your environment.") }))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: _resetConfig,
      isSubmitting,
      submitButtonText: "Update configuration",
      submitLoadingText: "Updating configuration..."
    }
  )))))));
};
export default AIReportConfiguration;
